// TextAreaControl.tsx
import React from 'react';

interface TextAreaControlProps {
    name: string;
    label: string;
    value?: string;
    placeholder?: string;
    rows?: number;
    cols?: number;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    hideLabel?: boolean;
    ariaLabel?: string;
    ariaLabelledBy?: string;
}

const TextAreaControl: React.FC<TextAreaControlProps> = ({
    name,
    label,
    value,
    placeholder,
    rows,
    cols,
    onChange,
    hideLabel = false,
    ariaLabel,
    ariaLabelledBy
}) => (
    <div>
        {hideLabel ? null : <label htmlFor={name}>{label}</label>}
        <textarea
            name={name}
            value={value}
            onChange={onChange}
            id={name}
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledBy}
            placeholder={placeholder}
            rows={rows}
            cols={cols}
        />
    </div>
);

export default TextAreaControl;
